import React from "react";

export const MissionContext = React.createContext({
    refreshMission: () => {},
    getPickingTotal: (wmsItems) => {},
    getInTrolleyTotal: (wmsItems) => {},
    getCancelledTotal: (wmsItems) => {},
    currentTask: null,
    currentContainer: null,
    retailerNewWmsItems: null,
    setRetailerNewWmsItems: (items) => {},
    selectedRetailers: [],
    setSelectedRetailers: (retailers) => {},
    retailersToBeAddedToMission: [],
    setRetailersToBeAddedToMission: (retailers) => {},
    putBatchItemsInTrolley: (itemsSku) => {},
    putWmsItemInTrolley: (wmsItem) => {},
});
